import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminInboxes = lazy(() => import("@/pages/admin/AdminInboxes"));
import { AdminLayout } from "@/components/admin/AdminLayout";
export const Route = createFileRoute("/admin/inboxes")({
  component: () => (
    <AdminLayout requiredPermission="view_audit_logs">
      <AdminInboxes />
    </AdminLayout>
  ),
});
